import image from "../../../image/image-auth.png";
import { BodyAuthComponents } from "../components/BodyAuth";
import logoWithoutName from "../../../image/logoWithoutName.svg";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import { Link } from "react-router-dom";
import { FormEvent, useState } from "react";
import { IconEye, IconEyeOutline, IconLeftArrowVersion2 } from "../../../icons";
import { isPasswordValid } from "../../../libs/validationPassaword";
import { InputIcon } from "../../../components/InputV2";
import { isEmailValid } from "../../../libs/validation-email";
import IconButton from "../../../components/IconButton";
import "./index.scss";
import { postNewAccount } from "../../../page/auth/service/service";
import useAuthData from "../../../hook/useAppData";
import { SuccessSignUp } from "./success";
import { Toaster } from "react-hot-toast";
import { toastError, toastSuccess } from "../../../components/Toast";
import { InputV3 } from "../../../components/InputV3";
import { ModalPopUp } from "../../../components/ModalPopUp";
import { TermLGPD } from "./term-lgpd";
import { remask, unRemask } from "../../../libs/remask-mask";

type TypePage = "newCorp" | "created" | "welcome";

export type RegisterCorporation = {
  name: string;
  corporation: string;
  email: string;
  phone: string;
  password: string;
  acceptedTerms: boolean;
};

export function SignUp() {
  const { setToken } = useAuthData();

  const [value, setValue] = useState<RegisterCorporation>({
    name: "",
    corporation: "",
    email: "",
    phone: "",
    password: "",
    acceptedTerms: false,
  });
  const [error, setError] = useState<{ name: string; corporation: string; email: string; phone: string; password: string }>({
    name: undefined,
    corporation: undefined,
    email: undefined,
    phone: undefined,
    password: undefined,
  });
  const [page, setPage] = useState<TypePage>("newCorp");
  const [hiddenPassword, setHiddendPassword] = useState(true);
  const [checkbox, setCheckbox] = useState(false);
  const [modalTerm, setModalTerm] = useState(false);

  async function handleSubmitSignUp(event: FormEvent) {
    event.preventDefault();
    if (verefyFieldsIfHasError()) return toastError("erro");
    const registerCorporation: Response = await postNewAccount({ ...value, acceptedTerms: checkbox });
    if (registerCorporation?.ok) {
      const registerCorporationJson = await registerCorporation.json();
      toastSuccess("Cadastro feito com sucesso");
      setToken(`Bearer ${registerCorporationJson.token}`);
      return setPage("created");
    }
    if (registerCorporation?.status === 409) return toastError("E-mail já cadastrado em outra empresa");
    toastError("Erro ao cadastrar, verifique seus dados e tente novamente em alguns instantes");
  }

  const verefyFieldsIfHasError = () => {
    const emailValid = isEmailValid(value.email);
    const passwordValid = isPasswordValid(value.password).validationPassword();
    let errors = 0;
    for (let field in value) {
      if (!value[field] && field !== "password" && field !== "acceptedTerms") errors += 1;
    }
    if (!emailValid) errors += 1;
    if (!passwordValid.isValid) errors += 1;

    setError({
      corporation: !value.corporation ? "Campo obrigatório!" : undefined,
      name: !value.name ? "Campo obrigatório!" : undefined,
      email: !value.email ? "Este será o seu login de acesso. Campo obrigatório!" : !emailValid ? "Email inválido!" : undefined,
      phone: !value.phone ? "Campo obrigatório!" : undefined,
      password: !value.password ? "Campo obrigatório!" : !passwordValid.isValid ? passwordValid.message : undefined,
    });
    return errors ? true : false;
  };

  function checkboxConfirm() {
    setCheckbox((oldState) => !oldState);
  }

  function exitPopUp() {
    return setModalTerm(false);
  }

  const updateValue = (target: { name: string; value: string }) => {
    const newValue = target.name === "phone" ? unRemask(target.value) : target.value;
    setValue({
      ...value,
      [target.name]: newValue,
    });
  };

  return (
    <>
      <Toaster position="top-left" />
      <BodyAuthComponents className="flex flex-col items-center justify-center gap-12">
        {page === "newCorp" && (
          <div className="w-full">
            <ModalPopUp status={modalTerm} onClickCancel={exitPopUp} className="position-modal max-h-70vh overflow-y-scroll">
              <TermLGPD />
            </ModalPopUp>
            <div className="flex flex-col items-center">
              <img src={logoWithoutName} className="w-28" />
              <h1 className="text-5xl font-semibold">Crie sua conta</h1>
              <p className="text-2xl my-2 text-textPrimary text-center">É rápido, fácil e grátis, crie sua conta agora mesmo.</p>
            </div>
            <form onSubmit={handleSubmitSignUp} className="w-full h-5/6 flex flex-col items-center gap-4">
              <div className="label-create-account w-flex flex-col items-center w-3/5 sm:w-4/5 gap-4">
                <Input
                  name="name"
                  label="Seu nome"
                  placeholder="Seu nome"
                  value={value.name}
                  setValue={(e) => {
                    if (value.name) setError({ ...error, name: undefined });
                    updateValue(e.target);
                  }}
                  errorMessage={error.name}
                  errorStatus={error.name ? true : false}
                  autofocus={true}
                />
                <Input
                  name="corporation"
                  label="Nome da Empresa"
                  placeholder="Nome da empresa"
                  value={value.corporation}
                  setValue={(e) => {
                    if (value.corporation) setError({ ...error, corporation: undefined });
                    updateValue(e.target);
                  }}
                  errorMessage={error.corporation}
                  errorStatus={error.corporation ? true : false}
                />
                <Input
                  name="email"
                  label="E-mail empresarial"
                  placeholder="Seu e-mail empresarial"
                  value={value.email}
                  setValue={(e) => {
                    if (value.email) setError({ ...error, email: undefined });
                    updateValue(e.target);
                  }}
                  errorStatus={error.email ? true : false}
                  errorMessage={error.email}
                />
                {!error.email ? <p className="ml-5 -mt-3 mb-3 text-xl text-textPrimary">Este será o seu login de acesso</p> : ""}
                <Input
                  name="phone"
                  setValue={(e: any) => {
                    updateValue(e.target);
                  }}
                  value={remask(value.phone, value.phone?.length < 11 ? ["(99) 9999-9999"] : ["(99) 9 9999-9999"])}
                  label="Telefone"
                  placeholder="Digite seu telefone"
                  type="text"
                  maxLength={16}
                  errorMessage={error.phone}
                  errorStatus={error.phone ? true : false}
                />
                <InputV3
                  inputProps={{
                    placeholder: "Defina uma senha",
                    autoFocus: true,
                    value: value?.password,
                    onChange: (e) => updateValue(e.target),
                    name: "password",
                    type: hiddenPassword ? "password" : "text",
                  }}
                  classNameBoxInput="ml-4"
                  labelProps={{
                    children: "Senha",
                  }}
                  iconButtonProps={{ icon: hiddenPassword ? IconEyeOutline : IconEye, onClick: () => setHiddendPassword((oldValue) => !oldValue) }}
                  errorStatus={error.password ? true : false}
                  errorMessage={error.password}
                />
                {!error.password ? (
                  <p className="w-full ml-5 mb-3 text-xl text-textPrimary">
                    Deve conter 8 caracteres sendo, no mínimo, uma letra maiúscula, um numeral e um símbolo.
                  </p>
                ) : (
                  ""
                )}
                <div className=" flex items-center w-5/6 gap-4 ml-4 bg-white text-textPrimary">
                  <input
                    name="term"
                    type="checkbox"
                    className="border border-newPrimary cursor-pointer"
                    checked={checkbox}
                    onClick={checkboxConfirm}
                    required={true}
                  />
                  <label>
                    Eu concordo com os{" "}
                    <span onClick={() => setModalTerm(true)} className="text-primary cursor-pointer">
                      Termos e condições de uso do Integra Admin
                    </span>{" "}
                  </label>
                </div>
              </div>
              <div className="flex flex-col items-center w-3/5 sm:w-4/5 gap-2 px-4">
                <Button type="submit" className="bg-primary w-full rounded-xl">
                  Criar conta
                </Button>
                <span className="text-lg mt-1 text-textPrimary">
                  Já tem uma conta?{" "}
                  <Link className="text-primary font-bold" to={"/login"}>
                    Faça o login
                  </Link>
                </span>
              </div>
            </form>
          </div>
        )}
        {page === "created" && (
          <>
            <SuccessSignUp value={value} />
          </>
        )}
      </BodyAuthComponents>
    </>
  );
}
